import {Grid, makeStyles} from '@logistics-frontend/blocks'
import clsx from 'clsx'
import React from 'react'

import {Timeline as timelineType} from 'src/api/cargo-c2c/types'
import {tagToUrl} from 'src/utils'

type Props = {
  timeline: timelineType
}

export const useStyles = makeStyles(
  theme => ({
    root: {
      paddingBottom: theme.spacing(2),
    },
    borderTop: {
      borderTopColor: '#d2d0cc',
      borderTopWidth: 1,
      borderTopStyle: 'solid',
    },
    image: {
      width: 24,
      height: 24,
    },
    imageContainer: {
      backgroundColor: theme.go.schemes.colors.system.BgMinor,
      borderRadius: 100,
      padding: theme.spacing(1),
      margin: theme.spacing(0, 1),
    },
    connector: {
      position: 'relative',
      '&::before': {
        content: '""',
        position: 'absolute',
        display: 'inline-block',
        left: '32px',
        height: 6,
        width: 16,
        backgroundColor: theme.go.schemes.colors.system.BgMinor,
      },
    },
    success: {
      backgroundColor: '#FCE000',
      '&::before': {backgroundColor: '#FCE000'},
    },
  }),
  {name: 'Timeline'},
)

const Timeline: React.FC<Props> = ({timeline}) => {
  const classes = useStyles()

  return (
    <Grid className={classes.root} justify="center" container>
      {timeline.horizontal.map((item, index) => (
        <Grid key={item.id} className={clsx(classes.imageContainer, item.status === 'passed' && classes.success)} item>
          <Grid
            alignItems="center"
            className={clsx(
              item.status === 'passed' && classes.success,
              index !== timeline.horizontal.length - 1 && classes.connector,
            )}
            container
            item
          >
            <img alt="" className={classes.image} loading="lazy" src={tagToUrl(item.image_tag)} />
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

export default Timeline
